import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

import { dateValidation } from '../validations';

const AMERICA_TIMEZONE = 'America/New_York';

export function checkDate(timeString: string | null) {
  if (!timeString) {
    return { isValidDate: false, value: '' };
  }

  if (!dateValidation(timeString.toString())) {
    return { isValidDate: false, value: timeString };
  }

  return { isValidDate: true, value: timeString };
}

export const getTimezoneGuess = () => {
  const timezone = dayjs.tz.guess();

  return timezone !== 'Etc/Unknown' ? timezone : 'UTC';
}

export function formatDate(timeString: string | null, format = 'MMM DD, YYYY [at] hh:mm A') {
  const { isValidDate, value } = checkDate(timeString);

  if (!isValidDate) return value;

  const timeWithDefaultTz = dayjs.tz(timeString, AMERICA_TIMEZONE);

  return timeWithDefaultTz.tz(getTimezoneGuess()).format(format);
}

export default (timeString: string | null, format?: string) => formatDate(timeString, format);

export const onlyDate = (timeString: string | null) => formatDate(timeString, 'MMM DD, YYYY');

export const fromNow = (timeString: string | null) => {
  const { isValidDate, value } = checkDate(timeString);

  if (!isValidDate) return value;

  const timeWithDefaultTz = dayjs.tz(timeString, AMERICA_TIMEZONE);

  return timeWithDefaultTz.tz(getTimezoneGuess()).fromNow();
};

export const getCurrentDate = () => dayjs().tz(AMERICA_TIMEZONE).format('YYYY-MM-DD HH:mm:ss');

export const getCurrentTimeCreate = () => dayjs()
  .tz(getTimezoneGuess())
  .tz(AMERICA_TIMEZONE)
  .format('YYYY-MM-DD HH:mm:ss');
